import axios from 'axios';
import { accountManagementAuthentication, nodeEnv, defaultClusterName } from '../../app.constants';
import { InitializeUserService } from 'modules/core/InitializeUserService';
import { FeatureToggleClientService } from 'feature-toggle-client';
const _blipLoginfeatureID = 'blip-login-cluster-configuration';
const _idpStatusCookieName = `${nodeEnv}-idp-status-data`;
const _idpContractCookieName = `${nodeEnv}-idp-contract-data`;
const _localStorageIssuerHelperId = 'oidc.azureB2CData';
const _clusterName = defaultClusterName.toLowerCase();
export class IdentityProviderSelector {
    constructor() { }
    static getInstance() {
        if (!IdentityProviderSelector.instance) {
            IdentityProviderSelector.instance = new IdentityProviderSelector();
        }
        return IdentityProviderSelector.instance;
    }
    getBlipLoginData() {
        return this.blipLoginData;
    }
    async isBlipLoginEnabled() {
        await this.setBlipLoginData();
        if (!this.blipLoginData.isEnabled) {
            this.setIssuerHelperOnLocalStorage();
            return false;
        }
        if (this.blipLoginData.IDP.isEnabled) {
            await this.checkIDPEnabled();
        }
        this.setIssuerHelperOnLocalStorage();
        return this.blipLoginData.isEnabled;
    }
    async setBlipLoginData() {
        await InitializeUserService.InitAnonymousFeatureToggle();
        const blipClusterLoginData = await FeatureToggleClientService.getInstance().isFeatureEnabled(_blipLoginfeatureID);
        const clusterToUse = _clusterName in blipClusterLoginData ? _clusterName : 'default';
        const dataForThisCluster = blipClusterLoginData[clusterToUse];
        this.blipLoginData = dataForThisCluster;
    }
    async setIssuerHelperOnLocalStorage() {
        const localStorageB2CData = {
            isEnabled: this.blipLoginData.isEnabled,
        };
        localStorage.setItem(_localStorageIssuerHelperId, JSON.stringify(localStorageB2CData));
    }
    async checkIDPEnabled() {
        this.idpStatusData = this.getCookie(_idpStatusCookieName);
        if (this.idpStatusData !== undefined) {
            this.blipLoginData.isEnabled = this.idpStatusData;
            return;
        }
        this.idpContractData = this.getCookie(_idpContractCookieName);
        const contractUrl = this.idpContractData ? this.idpContractData : location.origin;
        this.blipLoginData.isEnabled = await this.get(contractUrl);
        this.setIDPInUseCookie(contractUrl);
    }
    setIDPInUseCookie(contractUrl) {
        const isEnabled = this.blipLoginData.isEnabled;
        const contract = contractUrl;
        const DOMAIN = window.location.host.includes('blip.ai') ? '.blip.ai' : '.localdev.me';
        const statusExpireTime = new Date().getTime() + this.blipLoginData.IDP.statusExpireTime;
        const contractExpireTime = new Date().getTime() + this.blipLoginData.IDP.contractExpireTime;
        const statusOptions = {
            expires: new Date(statusExpireTime),
            path: '/',
            domain: DOMAIN,
        };
        const contractOptions = {
            expires: new Date(contractExpireTime),
            path: '/',
            domain: DOMAIN,
        };
        this.setCookie(_idpStatusCookieName, isEnabled, statusOptions);
        this.setCookie(_idpContractCookieName, contract, contractOptions);
    }
    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            const cookieValue = parts.pop()?.split(';').shift();
            return cookieValue ? JSON.parse(decodeURIComponent(cookieValue)) : undefined;
        }
        return undefined;
    }
    setCookie(name, value, options) {
        const cookieValue = encodeURIComponent(JSON.stringify(value));
        let cookieString = `${name}=${cookieValue}`;
        if (options.expires) {
            cookieString += `; expires=${options.expires.toUTCString()}`;
        }
        if (options.path) {
            cookieString += `; path=${options.path}`;
        }
        if (options.domain) {
            cookieString += `; domain=${options.domain}`;
        }
        document.cookie = cookieString;
    }
    async get(clientUri) {
        try {
            const VALIDATE_ENDPOINT = accountManagementAuthentication + '/ValidateAzureADClient';
            const params = { uri: clientUri };
            const response = await axios.get(VALIDATE_ENDPOINT, { params });
            return response.data.enableAzureADB2C;
        }
        catch (error) {
            return false;
        }
    }
}
